import { useQuery } from "@tanstack/react-query"
import { Link, useParams } from "react-router-dom"
import GameScreenLayout from "@/components/GameScreenLayout"
import { getPublicProfile } from "@/api/gameApi"
import { ELEMENT_NAMES, RANK_NAMES } from "@/constants/guardians"
import { displayCardBS } from "@/constants/game.constants"

export default function PublicProfilePage() {
  const { code } = useParams<{ code: string }>()
  const q = useQuery({
    queryKey: ["public-profile", code],
    queryFn: () => getPublicProfile(code!),
    enabled: Boolean(code),
  })

  const p = q.data

  return (
    <GameScreenLayout title="Профиль хранителя" backTo="/play">
      {q.isLoading ? (
        <p className="text-sm text-guardians-muted">Загрузка…</p>
      ) : q.isError || !p ? (
        <p className="text-sm text-red-300">Профиль не найден</p>
      ) : (
        <div className="space-y-4">
          <header className="rounded-xl border border-white/10 p-4">
            <h2 className="text-lg font-semibold">{p.nickname}</h2>
            <p className="text-xs text-guardians-muted">
              {p.publicGameCode} · {p.cityName ?? "—"}
            </p>
            <p className="mt-2 text-sm">
              {p.globalPts} глоб. / {p.localPts} лок. · карт {p.cardsCount}
            </p>
            {p.guild ? (
              <p className="text-xs text-guardians-accent">
                [{p.guild.tag}] {p.guild.name}
              </p>
            ) : null}
          </header>

          {p.almanac ? (
            <Link
              to={`/play/almanac/${encodeURIComponent(p.publicGameCode)}`}
              className="block text-sm text-guardians-accent underline"
            >
              Альманах: {p.almanac.stampedSlots}/{p.almanac.totalSlots}
            </Link>
          ) : null}

          <section>
            <h3 className="mb-2 text-sm font-medium">Карты</h3>
            <ul className="space-y-2">
              {p.cards.slice(0, 24).map((c) => (
                <li
                  key={c.id}
                  className="flex justify-between rounded-lg border border-white/10 px-3 py-2 text-sm"
                >
                  <span>
                    {ELEMENT_NAMES[c.element]} {RANK_NAMES[c.colorRank]} Lv.
                    {c.level}
                    {c.isActive ? " · активная" : ""}
                  </span>
                  <span className="text-guardians-muted">
                    BS {displayCardBS(c)}
                  </span>
                </li>
              ))}
            </ul>
          </section>
        </div>
      )}
    </GameScreenLayout>
  )
}
